import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "internalLabel" })
export class InternalLabelPipe implements PipeTransform {
   public transform(item: any, defaultLabel?: any): string {
      if (defaultLabel === "string") {
         return item;
      }

      return `${!defaultLabel ? item.name : item[defaultLabel]}`;
   }
}
